import type { Style } from '@wix/thunderbolt-becky-types'
import _ from 'lodash'
import { createDataNode } from '../nodeFactory/dataNodeUtils'

export const ComponentStyle = createDataNode({
	getDependencies: () => null,
	toViewItem: (dataItem: Style) => {
		const { skin } = dataItem
		return skin ? { ...dataItem, skin: skin.startsWith('svgshape.') ? skin : _.last(skin.split('.'))! } : dataItem
	},
})
